import Datatable from "./datatable_controller"

export default class extends Datatable {

  connect() {
    super.connect()
  }

  get columns() {
    return [
      {data: "contact"},
      {data: "source"},
      {data: "status"},
    ];
  }

  get searching() {
    return false
  }

  get ordering() {
    return false
  }
}
